<template>
  <div v-if="reservation_object">
    <v-btn
      :to="'/events/' + $route.params.id + '/' + $route.params.reservation_id"
      class="ma-0 mb-5"
      transparent
    >
      Назад
    </v-btn>
    <add-room-modal
      title="+ Добавить номер"
      @add-reservation="AddReservation"
    ></add-room-modal>

    <v-row v-if="reservation_object.reservation">
      <v-col
        cols="12"
        class="mb-6"
        xs="12"
        sm="12"
        md="12"
        lg="7"
      >
        <v-card class="overflow-hidden mb-5">
          <v-row class="ma-0 h-full">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card-title
                class="mt-2"
                style="font-size: 20px; font-weigth: bold"
              >
                {{ reservation_object.reservation.header }}
              </v-card-title>
            </v-col>
          </v-row>
        </v-card>
        <!-- Клиент -->
        <v-card class="mb-5 pricing-summary">
          <v-card-title>Клиент</v-card-title>
          <v-card-text class="pt-0">
            <template v-if="currentClient">
              <div class="pricing-row">
                <span class="pricing-label">Имя</span>
                <span class="pricing-value">{{ currentClient.name }}</span>
              </div>
              <div v-if="currentClient.phone" class="pricing-row">
                <span class="pricing-label">Телефон</span>
                <span class="pricing-value">{{ currentClient.phone }}</span>
              </div>
              <div v-if="currentClient.email" class="pricing-row">
                <span class="pricing-label">Email</span>
                <span class="pricing-value">{{ currentClient.email }}</span>
              </div>
              <v-divider class="my-3" />
              <div class="pricing-hint mb-2">Сменить клиента</div>
            </template>
            <div v-else class="pricing-hint mb-3">Клиент не указан</div>
            <v-autocomplete
              v-model="select_user"
              :items="clientAutocompleteItems"
              :search-input.sync="client_search"
              item-value="id"
              item-text="name"
              label="Поиск по имени, телефону или email"
              outlined
              dense
              clearable
              no-filter
              :loading="clients_loading"
            >
              <template v-slot:selection="{ item }">
                {{ item.name }}<span v-if="item.phone"> · {{ item.phone }}</span>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.phone }} · {{ item.email }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            <v-btn small text color="primary" class="mt-1" @click="createClientDialog = true">
              + Создать нового клиента
            </v-btn>
          </v-card-text>
        </v-card>
        <v-card
          v-for="room in reservation_object.reservation.suits"
          :key="room.id"
          class="overflow-hidden mb-10"
        >
          <v-row class="ma-0 h-full pt-5">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <div>
                <v-card-text class="d-flex align-center">
                  <div v-show="room.image">
                    <v-avatar
                      rounded
                      size="120"
                    >
                      <v-img :src="'https://lk.xbadm.ru' + room.image"></v-img>
                    </v-avatar>
                  </div>
                  <div>
                    <v-card-title> {{ room.name }} №{{ room.room_number }}</v-card-title>

                    <v-card-subtitle class="text-xs pb-0">
                      {{ room.options.package }} <br />
                      {{ room.room_available_type[0] }}
                    </v-card-subtitle>
                    <v-card-text class="mt-5">
                      <v-btn
                        x-small
                        depressed
                        color="primary"
                        class="mr-3"
                        @click="selectChangeRoom(room.id, room.reservation_room_id)"
                      >
                        Заменить номер
                      </v-btn>
                      <v-btn
                        x-small
                        depressed
                        color="error"
                        @click="deleteRoom(reservation_object.uuid, room.id)"
                      >
                        Удалить номер
                      </v-btn>
                    </v-card-text>
                  </div>
                </v-card-text>
                <v-card-text>
                  <v-divider></v-divider>
                </v-card-text>

                <div>
                  <v-card-title class="pb-0 mb-0">
                    Тип номера
                  </v-card-title>
                  <v-card-text>
                    <v-radio-group
                      v-model="room.options.type"
                      mandatory
                    >
                      <v-radio
                        v-for="(t, key) in room.room_available_type"
                        :key="t"
                        :label="t"
                        :value="key"
                      ></v-radio>
                    </v-radio-group>
                  </v-card-text>
                </div>

                <div v-show="room.options.type === '1'">
                  <v-card-title class="pb-0 mb-0">
                    Пол участника
                  </v-card-title>
                  <v-card-text>
                    <v-radio-group
                      v-model="room.options.gender"
                      mandatory
                    >
                      <v-radio
                        v-for="(g, key) in room.available_gender"
                        :key="g"
                        :label="g"
                        :value="key"
                      ></v-radio>
                    </v-radio-group>
                  </v-card-text>
                </div>

                <v-card-text>
                  <v-divider></v-divider>
                </v-card-text>

                <div
                  v-for="(participant, index) in room.participants"
                  :key="participant.index"
                >
                  <v-card-title>
                    <span>Данные {{ index + 1 }}-го участника </span>
                    <v-spacer></v-spacer>
                    <v-btn
                      x-small
                      color="error"
                      @click="deletePeople(room.participants, index)"
                    >
                      Удалить
                    </v-btn>
                  </v-card-title>

                  <v-card-text>
                    <v-text-field
                      v-model="participant.name"
                      outlined
                      hide-details
                      label="Фамилия Имя"
                      required
                    >
                    </v-text-field>

                    <v-switch
                      v-model="participant.show_in_list"
                      label="Показывать учатстника в общем списке участников"
                    ></v-switch>

                    <div
                      class="d-flex"
                      style="margin-bottom: 30px;"
                    >
                      <div>
                        <div class="label">
                          Дата заезда
                        </div>
                        <date-picker
                          v-model="participant.start"
                          :lang="lang"
                          type="date"
                          value-type="format"
                          class="v-input__control mr-md-4 mr-sm-4"
                          :format="'YYYY-MM-DD'"
                        ></date-picker>
                      </div>
                      <div>
                        <div class="label">
                          Дата выезда
                        </div>
                        <date-picker
                          v-model="participant.end"
                          :lang="lang"
                          type="date"
                          value-type="format"
                          class="v-input__control mr-md-4 mr-sm-4"
                          :format="'YYYY-MM-DD'"
                        ></date-picker>
                      </div>
                    </div>

                    <label for="participantType">Тип Питания</label>
                    <v-radio-group
                      id="participantType"
                      v-model="participant.food"
                      mandatory
                    >
                      <v-radio
                        label="Стандартное"
                        value="Стандартное"
                      ></v-radio>
                      <v-radio
                        label="Вегетарианское"
                        value="Вегетарианское"
                      ></v-radio>
                    </v-radio-group>

                    <label for="participantType">Тип участника</label>
                    <v-radio-group
                      id="participantType"
                      v-model="participant.participantType"
                      mandatory
                    >
                      <v-radio
                        label="Спортсмен"
                        value="Спортсмен"
                      ></v-radio>
                      <v-radio
                        label="Сопровождающий"
                        value="Сопровождающий"
                      ></v-radio>
                    </v-radio-group>

                    <label for="participantType">Возраст участника</label>
                    <v-radio-group
                      id="participantType"
                      v-model="participant.age"
                      mandatory
                    >
                      <v-radio
                        label="Взрослый"
                        value="Взрослый"
                      ></v-radio>
                      <v-radio
                        label="Ребенок (до 13 лет включительно)"
                        value="Ребенок (до 13 лет включительно)"
                      >
                      </v-radio>
                    </v-radio-group>

                    <v-text-field
                      v-show="participant.age != 'Взрослый'"
                      v-model="participant.childAge"
                      outlined
                      hide-details
                      label="Полных лет на дату заезда"
                      class="v-label_small"
                    >
                    </v-text-field>

                    <v-checkbox
                      v-model="participant.insurance"
                      hide-details
                      label="Добавить страховку от невыезда"
                    >
                    </v-checkbox>
                    <v-text-field
                      v-model="participant.discount_admin"
                      outlined
                      hide-details
                      label="Скидка"
                      class="v-label_small mt-5"
                      required
                    ></v-text-field>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                        >Дополнительная скидка участника <v-icon>{{ icons.mdiHelpCircle
                        }}</v-icon></span>
                      </template>
                      <span>Пример: Если система автоматически выдала клиенту скидку 10% <br> а в поле дополнительная
                        скидка
                        указано 5%, система сделает скидку 15%</span>
                    </v-tooltip>

                    <v-text-field
                      v-model="participant.discount_text"
                      outlined
                      hide-details
                      label="Текст скидки"
                      class="v-label_small mt-5"
                      required
                    ></v-text-field>
                    <v-switch
                      v-model="participant.no_count"
                      label="Скрыть участника из всех списков"
                    ></v-switch>

                    <v-divider class="mt-10"></v-divider>
                  </v-card-text>
                </div>
                <v-btn
                  v-if="room.participants.length < room.capacity"
                  x-small
                  class="small-btn"
                  color="primary"
                  @click="addPeople(room.participants)"
                >
                  Добавить участника
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        class="mb-12"
        xs="12"
        sm="12"
        md="12"
        lg="5"
      >
        <!-- 1. Услуги -->
        <v-card class="mb-5 pricing-summary">
          <v-card-title>
            Услуги
            <v-spacer />
            <v-btn small color="primary" @click="openAddService">
              <v-icon left small>mdi-plus</v-icon>Добавить
            </v-btn>
          </v-card-title>
          <v-card-text class="pt-0">
            <div v-if="!reservation_object.services || !reservation_object.services.length" class="pricing-hint">
              Услуги не добавлены
            </div>
            <template v-else>
              <div
                v-for="svc in reservation_object.services"
                :key="svc.id"
                class="service-block"
              >
                <div class="pricing-row">
                  <span class="pricing-label">
                    {{ svc.name }}
                    <span class="pricing-meta">{{ svc.unit_price | format }} ₽ × {{ svc.quantity }}</span>
                  </span>
                  <span class="pricing-value pricing-value--action">
                    <span>{{ svc.total_price | format }} ₽</span>
                    <v-btn
                      icon
                      x-small
                      color="error"
                      class="ml-1"
                      @click="removeService(svc)"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </span>
                </div>
                <div
                  v-if="svc.discount > 0"
                  class="pricing-row pricing-row--discount"
                >
                  <span class="pricing-label">{{ svc.discount_text || 'Скидка' }}</span>
                  <span class="pricing-value">−{{ svc.discount | format }} ₽</span>
                </div>
              </div>
              <v-divider class="my-3" />
              <div class="pricing-row pricing-row--subtotal">
                <span class="pricing-label">Итого по услугам</span>
                <span class="pricing-value">{{ servicesTotal | format }} ₽</span>
              </div>
            </template>
          </v-card-text>
        </v-card>

        <!-- 2. Промокод и процентные скидки -->
        <v-card class="mb-5">
          <v-card-title class="pt-7">Промокод и скидки</v-card-title>
          <v-card-text>
            <v-divider class="mb-4" />
            <v-select
              v-model="reservation_object.payment_option"
              :items="paymentOptionItems"
              item-value="value"
              item-text="text"
              outlined
              dense
              hide-details
              label="Способ оплаты"
            />
            <div v-if="Number(reservation_object.payment_option) === 1" class="pricing-hint mt-2">
              Применяется скидка 5% за оплату наличными.
            </div>
            <div v-else class="pricing-hint mt-2">
              Скидка за наличные не применяется.
            </div>
          </v-card-text>

          <v-card-text>
            <v-select
              v-model="promo_code_add"
              :items="promo_codes_list"
              item-value="name"
              :item-text="promoItemLabel"
              label="Промокод"
              clearable
              outlined
              dense
              hide-details
              :loading="promo_loading"
              class="mt-2"
              @change="onPromoCodeChange"
            />
          </v-card-text>

          <v-card-text>
            <v-text-field
              v-model="reservation_object.additional_discount"
              type="number"
              :rules="[v => v !== '' && v != null || 'Скидка не может быть пустой', v => v < 96 || 'Скидка не может быть больше 95%']"
              outlined
              dense
              label="Дополнительная скидка, %"
              suffix="%"
            />
          </v-card-text>
        </v-card>

        <!-- 3. Пошаговый расчёт -->
        <v-card class="mb-5 pricing-summary">
          <v-card-title>Расчёт стоимости</v-card-title>
          <v-card-text class="pt-0">
            <div class="pricing-row">
              <span class="pricing-label">Номера и участники</span>
              <span class="pricing-value">{{ roomsTotal | format }} ₽</span>
            </div>
            <div v-if="servicesTotal > 0" class="pricing-row">
              <span class="pricing-label">Услуги</span>
              <span class="pricing-value">{{ servicesTotal | format }} ₽</span>
            </div>
            <v-divider class="my-3" />
            <div class="pricing-row pricing-row--subtotal">
              <span class="pricing-label">Итого по тарифу</span>
              <span class="pricing-value">{{ tariffTotal | format }} ₽</span>
            </div>

            <template v-if="promoDiscount > 0">
              <div class="pricing-row pricing-row--discount">
                <span class="pricing-label">Промокод</span>
                <span class="pricing-value">−{{ promoDiscount | format }} ₽</span>
              </div>
            </template>

            <div
              v-for="(line, idx) in percentDiscountLines"
              :key="'disc-' + idx"
              class="pricing-row pricing-row--discount"
            >
              <span class="pricing-label">{{ line.text }}</span>
              <span class="pricing-value">−{{ line.amount | format }} ₽</span>
            </div>

            <v-divider class="my-3" />
            <div class="pricing-row pricing-row--calculated">
              <span class="pricing-label">Расчётная сумма</span>
              <span class="pricing-value">{{ calculatedPayPrice | format }} ₽</span>
            </div>
            <div v-if="!tariffSynced" class="pricing-hint mt-2">
              Сохраните бронь, чтобы пересчитать суммы после изменения состава.
            </div>
          </v-card-text>
        </v-card>

        <!-- 4. Ручная корректировка — в конце -->
        <v-card class="mb-5">
          <v-card-title>
            Корректировка итога
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small class="ml-1" v-on="on">mdi-information-outline</v-icon>
              </template>
              Задайте фиксированную сумму к оплате. Корректировка применяется после расчёта тарифа и всех скидок.
            </v-tooltip>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model.number="reservation_object.manual_total"
              type="number"
              outlined
              dense
              clearable
              label="Фиксированная сумма к оплате"
              placeholder="Пусто — использовать расчётную сумму"
              min="0"
              hide-details
              @click:clear="reservation_object.manual_total = null"
            />
            <v-text-field
              v-if="reservation_object.manual_total != null"
              v-model="reservation_object.manual_discount_text"
              outlined
              dense
              hide-details
              class="mt-3"
              label="Описание корректировки"
            />

            <template v-if="reservation_object.manual_total != null">
              <v-divider class="my-3" />
              <div class="pricing-row pricing-row--discount">
                <span class="pricing-label">{{ reservation_object.manual_discount_text || 'Корректировка суммы' }}</span>
                <span class="pricing-value">−{{ manualAdjustment | format }} ₽</span>
              </div>
            </template>

            <v-divider class="my-3" />
            <div class="pricing-row pricing-row--total">
              <span class="pricing-label">К оплате</span>
              <span class="pricing-value pricing-value--total">{{ finalPayPrice | format }} ₽</span>
            </div>
          </v-card-text>
        </v-card>

        <v-btn
          block
          large
          color="success"
          class="mb-8"
          @click="updateReservation()"
        >
          Сохранить
        </v-btn>
      </v-col>
    </v-row>

    <!-- Диалог добавления услуги -->
    <v-dialog v-model="addServiceDialog" max-width="480">
      <v-card>
        <v-card-title>Добавить услугу</v-card-title>
        <v-card-text>
          <v-select
            v-model="newService.service_id"
            :items="catalogServices"
            item-value="id"
            item-text="name"
            label="Услуга из каталога"
            outlined
            dense
            clearable
            @change="onCatalogServiceChange"
          />
          <v-text-field v-model="newService.name" outlined dense label="Название" />
          <v-text-field v-model.number="newService.unit_price" type="number" outlined dense label="Цена за единицу, ₽" min="0" />
          <v-text-field v-model.number="newService.quantity" type="number" outlined dense label="Кол-во" min="1" />
          <v-text-field v-model.number="newService.discount" type="number" outlined dense label="Скидка, ₽" min="0" />
          <v-text-field v-model="newService.discount_text" outlined dense label="Описание скидки" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="addServiceDialog = false">Отмена</v-btn>
          <v-btn color="primary" :loading="addServiceLoading" @click="doAddService">Добавить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Диалог создания клиента -->
    <v-dialog v-model="createClientDialog" max-width="480">
      <v-card>
        <v-card-title>Создать клиента</v-card-title>
        <v-card-text>
          <v-text-field v-model="newClient.name" outlined dense label="Имя" />
          <v-text-field v-model="newClient.phone" outlined dense label="Телефон (+79...)" />
          <v-text-field v-model="newClient.email" outlined dense label="Email" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="createClientDialog = false">Отмена</v-btn>
          <v-btn color="primary" :loading="createClientLoading" @click="doCreateClient">Создать</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="new_reservation_popup"
      width="100%"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Выберете номер
        </v-card-title>
        <template>
          <v-tabs
            v-model="room_tabs"
            align-with-title
          >
            <v-tab
              v-for="packages in free_event_rooms.packages"
              :key="packages.id"
            >
              {{ packages.packageName }}
            </v-tab>
          </v-tabs>
        </template>

        <v-tabs-items v-model="room_tabs">
          <v-tab-item
            v-for="item in free_event_rooms.packages"
            :key="item.id"
          >
            <v-simple-table>
              <template v-if="free_event_rooms">
                <thead>
                  <tr>
                    <th class="text-left">
                      Id
                    </th>
                    <th>Номер</th>
                    <th>Тип номера</th>
                    <th>Пол номера</th>
                    <th>Свободных мест</th>
                    <th>Действие</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="suit in item.suits"
                    :key="suit.id"
                  >
                    <td>{{ suit.id }}</td>
                    <td>{{ suit.name }} - {{ suit.room_number }}</td>
                    <td>{{ suit.order_room_type_name }}</td>
                    <td>{{ suit.gender_room_type_name }}</td>
                    <td>{{ suit.free_places }}</td>
                    <td>
                      <v-btn
                        x-small
                        color="success"
                        @click="changeRoom(suit.id)"
                      >
                        Выбрать
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/api'
import Autocomplete from '@/components/Autocomplete.vue'
import AddRoomModal from '@/views/events/AddRoomModal.vue'
import {
  mdiHelpCircle,
} from '@mdi/js'
import DatePicker from 'vue2-datepicker'
import { mapActions } from 'vuex'

export default {
  components: { AddRoomModal, Autocomplete, DatePicker },
  filters: {
    format: val => {
      if (val == null || val === '') return '0'
      return `${val}`.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ')
    },
  },
  data() {
    return {
      users_list: [],
      clients_list: [],
      client_search: null,
      clients_loading: false,
      search_user: null,
      select_user: null,
      free_event_rooms: [],
      new_reservation_popup: false,
      reservation_object: Array,
      old_room_id: null,
      old_reservation_room_id: null,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      menu: false,
      date_arrival_modal: false,
      promo_code_add: null,
      promo_code_previous: null,
      promo_codes_list: [],
      promo_loading: false,
      room_tabs: null,
      headers_rooms: [{ text: 'Номер', value: 'name', align: 'start' }],
      // Услуги
      addServiceDialog: false,
      addServiceLoading: false,
      catalogServices: [],
      newService: { service_id: null, name: '', unit_price: 0, quantity: 1, discount: 0, discount_text: '' },
      // Создание клиента
      createClientDialog: false,
      createClientLoading: false,
      newClient: { name: '', phone: '', email: '' },
      icons: {
        mdiHelpCircle,
      },
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
    }
  },
  computed: {
    currentClient() {
      if (!this.reservation_object || !this.reservation_object.user_id) return null

      const fromList = this.clients_list.find(
        c => c.id === this.reservation_object.user_id,
      )
      if (fromList) return fromList

      return {
        id: this.reservation_object.user_id,
        name: this.reservation_object.user_name || 'Клиент',
        phone: this.reservation_object.user_phone || '',
        email: this.reservation_object.user_email || '',
      }
    },
    clientAutocompleteItems() {
      const items = [...this.clients_list]
      const current = this.currentClient
      if (current && !items.some(c => c.id === current.id)) {
        items.unshift(current)
      }
      return items
    },
    paymentOptionItems() {
      const items = [
        { value: 1, text: 'Наличные (скидка 5%)' },
        { value: 3, text: 'Карта / СБП (без скидки за наличные)' },
      ]
      if (Number(this.reservation_object && this.reservation_object.event_payment_option) === 2) {
        items.splice(1, 0, { value: 2, text: 'Предоплата' })
      }
      return items
    },
    roomsTotal() {
      const suits = (this.reservation_object && this.reservation_object.reservation && this.reservation_object.reservation.suits) || []
      return suits.reduce((sum, room) => sum + (Number(room.price) || 0), 0)
    },
    servicesTotal() {
      const services = (this.reservation_object && this.reservation_object.services) || []
      return services.reduce((sum, svc) => sum + (Number(svc.total_price) || 0), 0)
    },
    tariffTotal() {
      return this.roomsTotal + this.servicesTotal
    },
    tariffSynced() {
      if (!this.reservation_object) return true
      return Math.abs(Number(this.reservation_object.price || 0) - this.tariffTotal) < 1
    },
    promoDiscount() {
      if (!this.reservation_object) return 0
      return Number(this.reservation_object.price_promo_code) || 0
    },
    localRawPrice() {
      if (!this.reservation_object) return 0
      if (this.tariffSynced) {
        return Number(this.reservation_object.price) || 0
      }
      return this.tariffTotal
    },
    localDiscountPercent() {
      if (!this.reservation_object) return 0
      let n = Number(this.reservation_object.additional_discount) || 0
      n += Number(this.reservation_object.family_discount) || 0
      if (Number(this.reservation_object.payment_option) === 1) n += 5
      return Math.min(n, 100)
    },
    localPriceDiscount() {
      const raw = this.localRawPrice
      const n = this.localDiscountPercent
      if (n <= 0 || raw <= 0) return 0
      return Math.floor(raw * n / 100 / 10) * 10
    },
    percentDiscountLines() {
      if (!this.reservation_object) return []
      if (this.reservation_object.manual_total != null && this.reservation_object.manual_total !== '') return []

      const totalDiscount = this.localPriceDiscount
      if (totalDiscount <= 0) return []

      const parts = []
      if (Number(this.reservation_object.payment_option) === 1) {
        parts.push({ text: 'Оплата наличными (5%)', weight: 5 })
      }
      if (Number(this.reservation_object.family_discount) > 0) {
        parts.push({ text: 'Семейная скидка', weight: Number(this.reservation_object.family_discount) })
      }
      if (Number(this.reservation_object.additional_discount) > 0) {
        parts.push({ text: 'Дополнительная скидка', weight: Number(this.reservation_object.additional_discount) })
      }

      const weightSum = parts.reduce((s, p) => s + p.weight, 0)
      if (weightSum === 0) {
        return [{ text: 'Скидки', amount: totalDiscount }]
      }

      const lines = []
      let allocated = 0
      parts.forEach((part, idx) => {
        const amount = idx === parts.length - 1
          ? totalDiscount - allocated
          : Math.floor(totalDiscount * part.weight / weightSum / 10) * 10
        allocated += amount
        if (amount > 0) {
          lines.push({ text: part.text, amount })
        }
      })

      return lines
    },
    calculatedPayPrice() {
      if (!this.reservation_object) return 0
      return this.localRawPrice - this.promoDiscount - this.localPriceDiscount
    },
    manualAdjustment() {
      if (!this.reservation_object || this.reservation_object.manual_total == null) return 0
      return this.calculatedPayPrice - Number(this.reservation_object.manual_total)
    },
    finalPayPrice() {
      if (!this.reservation_object) return 0
      if (this.reservation_object.manual_total != null && this.reservation_object.manual_total !== '') {
        return Number(this.reservation_object.manual_total)
      }
      return this.calculatedPayPrice
    },
  },
  watch: {
    async client_search(val) {
      if (!val || val.length < 2) return
      this.clients_loading = true
      try {
        const results = await Api.getClients({ search: val })
        const current = this.currentClient
        if (current && !results.some(c => c.id === current.id)) {
          this.clients_list = [current, ...results]
        } else {
          this.clients_list = results
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.clients_loading = false
      }
    },
    select_user(val) {
      if (val && this.reservation_object) {
        this.reservation_object.user_id = val
        const client = this.clientAutocompleteItems.find(c => c.id === val)
        if (client) {
          this.reservation_object.user_name = client.name
          this.reservation_object.user_phone = client.phone
          this.reservation_object.user_email = client.email || ''
        }
      }
    },
  },
  created() {
    this.$watch(
      () => this.$route.params,
    )
  },
  async mounted() {
    await this.loadPromocodes()
    await this.getFrontReservation()
    await this.loadCatalogServices()
  },
  methods: {
    promoItemLabel(item) {
      if (!item) return ''
      const used = item.used != null ? ` · применений: ${item.used}` : ''
      const today = new Date().toISOString().slice(0, 10)
      const expired = item.expired_date && item.expired_date < today ? ' · истёк' : ''
      return `«${item.name}» — скидка ${item.discount}%${used}${expired}`
    },
    syncPromoCodeFromReservation() {
      const name = this.reservation_object?.reservation?.promo_code?.name || null
      this.promo_code_add = name
      this.promo_code_previous = name
    },
    async loadPromocodes() {
      try {
        const data = await Api.getPromocodes({
          event_id: parseInt(this.$route.params.id),
        })
        this.promo_codes_list = Array.isArray(data) ? data : []
      } catch (e) {
        console.error(e)
      }
    },
    getPromoApiError(error) {
      return (
        error?.response?.data?.error
        || error?.response?.data?.detail
        || 'Не удалось применить промокод'
      )
    },
    seedClientFromReservation(event) {
      if (!event || !event.user_id) return

      const current = {
        id: event.user_id,
        name: event.user_name || 'Клиент',
        phone: event.user_phone || '',
        email: event.user_email || '',
      }

      if (!this.clients_list.some(c => c.id === current.id)) {
        this.clients_list = [current, ...this.clients_list]
      }
    },
    async getFrontReservation() {
      try {
        const event = await Api.getReservation({
          reservation_uuid: this.$route.params.reservation_id,
        })
        if (event.payment_option != null) {
          event.payment_option = Number(event.payment_option)
        }
        this.$set(this, 'reservation_object', event)
        this.$set(this, 'select_user', event.user_id)
        this.seedClientFromReservation(event)
        this.syncPromoCodeFromReservation()
      } catch (error) {
        if (error.response?.status === 400) {
          this.$router.push({
            path: `/events/${this.$route.params.id}`,
            replace: true,
          })
        }
      }
    },
    async getUsers() {
      try {
        Api.getUsers().then(
          (event => {
            this.$set(this, 'users_list', event)
          }),
        )
      } catch { }
    },
    ...mapActions(['addReservationData']),
    async AddReservation(event_room_id) {
      try {
        Api.AddReservation({
          event_room_id,
          reservation_uuid: this.reservation_object.uuid,
        }).then(
          (event => {
            if (event.reservation_uuid) {
              this.getFrontReservation()
            }
          }),
        )
      } catch (error) {
        this.loader = false
      }
    },
    async selectChangeRoom(room_id, reservation_room_id) {
      console.log(room_id, reservation_room_id)
      Api.getFreeEventRooms({
        event_id: parseInt(this.$route.params.id),
      }).then(
        (event => {
          this.$set(this, 'free_event_rooms', event)
          this.$set(this, 'new_reservation_popup', true)
          this.$set(this, 'old_room_id', room_id)
          this.$set(this, 'old_reservation_room_id', reservation_room_id)
        }),
      )
    },
    async changeRoom(new_room_id) {
      this.$set(this, 'new_reservation_popup', false)
      Api.changeRoomAdmin({
        reservation_uuid: this.reservation_object.reservation_uuid,
        room_id: parseInt(this.old_room_id),
        reservation_room_id: parseInt(this.old_reservation_room_id),
        new_room_id: parseInt(new_room_id),
      }).then(
        (event => {
          this.$set(this, 'old_room_id', null)
          this.$set(this, 'old_reservation_room_id', null)
          this.getFrontReservation()
        }),
      )
    },
    async updateReservation() {
      try {
        Api.updateReservation(this.reservation_object).then(
          (event => {
            this.$router.push({
              path: `/events/${this.$route.params.id}/${this.$route.params.reservation_id}`,
              replace: true,
            })

            // this.checkInvoice()
          }),
        )
      } catch { }
    },
    async checkInvoice() {
      try {
        Api.checkInvoice({
          reservation_uuid: this.reservation_object.reservation_uuid,
        }).then(
          (event => {
            this.$router.push({
              path: `/events/${this.$route.params.id}/${this.$route.params.reservation_id}`,
              replace: true,
            })
          }),
        )
      } catch { }
    },
    async deleteRoom(reservation_uuid, event_room_id) {
      try {
        Api.deleteRoom({
          reservation_uuid,
          event_room_id,
        })
          .then(
            (event => {
              this.getFrontReservation()
            }),
          )
          .catch(error => {
            if (error.response.status === 400) {
              this.$router.push({
                path: `/events/${this.$route.params.id}`,
                replace: true,
              })
            } else {
              // Handle else
            }
          })
      } catch (error) {
        console.log(error)
      }
    },
    deletePeople(array, index) {
      // console.log(participant, index)
      array.splice(index, 1)
    },
    addPeople(array) {
      array.push({
        age: '',
        childAge: null,
        gender: '',
        food: '',
        insurance: false,
        show_in_list: true,
        no_count: false,
        name: '',
        participantType: '',
        phone: '',
        start: array[0] ? array[0].start : null,
        end: array[0] ? array[0].end : null,
      })
    },
    async onPromoCodeChange(value) {
      if (!this.reservation_object?.reservation) return

      const previous = this.promo_code_previous
      if (value === previous) return

      this.promo_loading = true
      try {
        if (!value) {
          if (previous) {
            await Api.promoCodeDelete({
              event_id: this.reservation_object.reservation.event_id,
              promo_code: previous,
              user_reservation_uuid: this.reservation_object.reservation_uuid,
            })
          }
        } else {
          await Api.promoCodeAdd({
            event_id: this.reservation_object.reservation.event_id,
            promo_code: value,
            user_reservation_uuid: this.reservation_object.reservation_uuid,
          })
        }
        await this.getFrontReservation()
      } catch (error) {
        this.promo_code_add = previous
        alert(this.getPromoApiError(error))
      } finally {
        this.promo_loading = false
      }
    },
    updateSelected(data) {
      this.reservation_object.user_id = data.id
    },

    // --- Услуги ---
    async loadCatalogServices() {
      try {
        this.catalogServices = await Api.getEventServices({
          event_id: this.$route.params.id,
        })
      } catch (e) {
        console.error(e)
      }
    },
    openAddService() {
      this.newService = { service_id: null, name: '', unit_price: 0, quantity: 1, discount: 0, discount_text: '' }
      this.addServiceDialog = true
    },
    onCatalogServiceChange(id) {
      const svc = this.catalogServices.find(s => s.id === id)
      if (svc) {
        this.newService.name = svc.name
        this.newService.unit_price = svc.price
      }
    },
    async doAddService() {
      if (!this.newService.name) return
      this.addServiceLoading = true
      try {
        const result = await Api.addReservationService({
          reservation_uuid: this.$route.params.reservation_id,
          ...this.newService,
        })
        if (!this.reservation_object.services) {
          this.$set(this.reservation_object, 'services', [])
        }
        this.reservation_object.services.push(result)
        this.addServiceDialog = false
        await this.getFrontReservation()
      } catch (e) {
        console.error(e)
      } finally {
        this.addServiceLoading = false
      }
    },
    async removeService(svc) {
      try {
        await Api.deleteReservationService({ id: svc.id })
        await this.getFrontReservation()
      } catch (e) {
        console.error(e)
      }
    },

    // --- Создание клиента ---
    async doCreateClient() {
      if (!this.newClient.phone) return
      this.createClientLoading = true
      try {
        const result = await Api.createClientAdmin(this.newClient)
        this.clients_list = [result, ...this.clients_list.filter(c => c.id !== result.id)]
        this.select_user = result.id
        if (this.reservation_object) {
          this.reservation_object.user_id = result.id
          this.reservation_object.user_name = result.name
          this.reservation_object.user_phone = result.phone
          this.reservation_object.user_email = result.email || ''
        }
        this.createClientDialog = false
        this.newClient = { name: '', phone: '', email: '' }
      } catch (e) {
        console.error(e)
      } finally {
        this.createClientLoading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.pricing-summary,
.v-card {
  .pricing-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 6px 0;
    font-size: 14px;
  }

  .pricing-label {
    color: rgba(0, 0, 0, 0.7);
    padding-right: 12px;
  }

  .pricing-value {
    font-weight: 500;
    white-space: nowrap;
  }

  .pricing-row--subtotal .pricing-label,
  .pricing-row--subtotal .pricing-value {
    font-weight: 600;
  }

  .pricing-row--discount {
    .pricing-label,
    .pricing-value {
      color: #2e7d32;
      font-size: 13px;
    }
  }

  .pricing-row--calculated {
    .pricing-label,
    .pricing-value {
      font-weight: 600;
      font-size: 15px;
    }
  }

  .pricing-row--total {
    padding-top: 4px;

    .pricing-label {
      font-size: 16px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.87);
    }

    .pricing-value--total {
      font-size: 20px;
      font-weight: 700;
      color: #1565c0;
    }
  }

  .pricing-hint {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
    font-style: italic;
  }

  .pricing-meta {
    display: block;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    font-weight: 400;
    margin-top: 2px;
  }

  .pricing-value--action {
    display: inline-flex;
    align-items: center;
    gap: 2px;
  }

  .service-block + .service-block {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px dashed rgba(0, 0, 0, 0.08);
  }
}
</style>
